<template>
    <div class="main">
        <div class="body-content">
            <div class="page-header" style="display: flex; align-items: center; justify-content: space-between;">
                <h1 style="margin: 0;">Coprar Convert</h1>
                <label class="checkbox-pill" :class="{ 'checkbox-pill--checked': newContainer.isEmpty }">
                    <input class="checkbox-input" type="checkbox" v-model="newContainer.isEmpty" name="isEmpty" value="true">
                    <span class="checkbox-box" aria-hidden="true"></span>
                    <span>Empty Container Convert to Coprar</span>
                </label>
            </div>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <v-select :clearable="false" tabindex="0" placeholder="Select Party Name" id="partyname"
                        v-model="newContainer.partyName" :options="party" label="short_name"
                        :reduce="party => party.autoid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="vcnname">VCN No *</label>
                    <v-select :clearable="false" id="vcnname" v-model="newContainer.vcnID" :options="vcns"
                        @v-on:change="FillVCNDetails" label="vcnName" :reduce="vcn => vcn.vcnID" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="vesselName">Vessel *</label>
                    <v-select :clearable="false" id="vesselName" placeholder="Select Vessel"
                        v-model="newContainer.vesselID" ref="vesselName" :options="vessel" label="Name"
                        :reduce="vessel => vessel.Vesselid" selectOnTab="True" />
                </div>

                <div class="form-item">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage"
                        label="Name" :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="location">Location:</label>
                    <v-select :clearable="false" id="location" v-model="newContainer.locID" :options="location"
                        label="Name" :reduce="location => location.locationid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="port">Transhipment:</label>
                    <v-select id="port" :clearable="false" v-model="newContainer.pod" :options="ports" label="PortCode"
                        :reduce="port => port.portid" placeholder="Select POD" selectOnTab="True" />
                </div>
            </div>
            <div class="form-group">
                <div class="form-item">
                    <label for="fileAdd">File:</label>
                    <input type="file" id="file" @change="handleFileUpload" class="custom-file-input"
                        :accept="newContainer.isEmpty ? '.xls,.xlsx' : '.xls,.xlsx,.zip'">
                </div>
                <div class="form-item" style="display: flex; align-items: center; gap: 15px;">
                    <label class="checkbox-pill" :class="{ 'checkbox-pill--checked': newContainer.israil }">
                        <input class="checkbox-input" type="checkbox" v-model="newContainer.israil" name="israil" value="true">
                        <span class="checkbox-box" aria-hidden="true"></span>
                        <span>Is Rail?</span>
                    </label>

                    <label class="checkbox-pill" :class="{ 'checkbox-pill--checked': newContainer.is_soc }">
                        <input class="checkbox-input" type="checkbox" v-model="newContainer.is_soc" name="is_soc" value="true">
                        <span class="checkbox-box" aria-hidden="true"></span>
                        <span>Is SOC?</span>
                    </label>
                </div>
                <div v-if="newContainer.isEmpty" style="margin-bottom: 12px;">
                    <label style="font-weight:600; display:block; margin-bottom:4px;">Paste container list (Tip: Excel
                    copy/paste TSV rows, format: Container No[tab]ISO Code)</label>
                    <textarea v-model="advanceContainerText" @input="parseAdvanceContainerRows" rows="6"
                    style="width:100%; border:1px solid #ccc; border-radius:4px; padding:8px;"></textarea>
                    <table v-if="advanceContainerRows.length" class="container-input-table">
                        <thead>
                            <tr>
                                <th>Location</th>
                                <th>Depot</th>
                                <th>Equipment#</th>
                                <th>Size</th>
                                <th>Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(container, index) in advanceContainerRows" :key="`${container.equipment}-${index}`">
                                <td>{{ container.location }}</td>
                                <td>{{ container.depot }}</td>
                                <td>{{ container.equipment }}</td>
                                <td>{{ container.size }}</td>
                                <td>{{ container.type }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="uploadFiles" :disabled="isSubmitting">Convert</button>
                </div>
            </div>
            <hr />
            <div class="table-container">
                <table class="transaction-table table-design">
                    <thead>
                        <tr>
                            <th>Sl No</th>
                            <th v-if="newContainer.isEmpty==false">File Name</th>
                            <th>Container No</th>
                            <th>ISO Size</th>
                            <th>FL/MT</th>
                            <th>STare Wt</th>
                            <th>SGross Wt</th>
                            <th>POL</th>
                            <th>POD</th>
                            <th>FPD</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ld, index) in fetchedList" :key="ld[0]"
                            :class="{ 'status-error': ld[9] !== 'Uploaded' }">
                            <td>{{ index + 1 }}</td>
                            <td v-if="newContainer.isEmpty==false">{{ ld[0] }}</td>
                            <td>{{ ld[1] }}</td>
                            <td>{{ ld[2] }}</td>
                            <td>{{ ld[3] }}</td>
                            <td>{{ ld[4] }}</td>
                            <td>{{ ld[5] }}</td>
                            <td>{{ ld[6] }}</td>
                            <td>{{ ld[7] }}</td>
                            <td>{{ ld[8] }}</td>
                            <td>{{ ld[9] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <hr />
            <h1>Generate PDF</h1>
            <div class="form-group">
                <div class="form-item">
                    <label for="oldcoprarno">Old Coprar No *</label>
                    <input id="oldcoprarno" class="field-p-100" v-model="oldcoprarno" />
                </div>
                <div class="form-item">
                    <label for="newcoprarno">New Coprar No *</label>
                    <input id="newcoprarno" class="field-p-100" v-model="newcoprarno" />
                </div>
                <div class="form-item">
                    <label for="filetype">File Type *</label>
                    <select id="filetype" class="field-p-100" v-model="filetype">
                        <option value="1">PDF</option>
                        <option value="2">Excel</option>
                    </select>
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="generatepdf" :disabled="isSubmitting">Generate</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
//import { part } from 'core-js/core/function';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import * as cs from '../assets/js/commonscript.js'

export default {
    components: {
        VSelect,
    },
    data() {
        return {
            transactions: [],
            party: JSON.parse(localStorage.getItem('party')),
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            location: JSON.parse(localStorage.getItem('Area')) || [],
            ports: JSON.parse(localStorage.getItem('ports')) || [],
            vcns: [],
            uploadlist: [],
            oldcoprarno: "",
            newcoprarno: "",
            filetype: 1, // 1 for PDF, 2 for Excel
            isSubmitting: false,
            advanceContainerText: '',
            advanceContainerRows: [],
            newContainer: {
                partyName: 0,
                applicantID: 0,
                accountID: 0,
                vesselID: 0,
                vesselname: '',
                consign: '',
                vcnID: 0,
                VoyId: 0,
                voyage: '',
                pod: 128,
                podcode: '',
                locID: 0,
                israil: false,
                is_soc: false,
                isEmpty: false,
                file: null,
            },
            htmlContent: null,
        }
    },
    created() {
        this.fetchVcnList();
    },
    computed: {
        fetchedList() {
            //console.log(this.successfulTasks);
            //console.log(this.uploadlist);
            return this.uploadlist;
        },
    },
    watch: {
        'newContainer.vcnID'(value) {
            this.FillVCNDetails(value)
        },
        'newContainer.isEmpty'(value) {
            if (this.newContainer.file && !this.isAllowedFile(this.newContainer.file, value)) {
                this.newContainer.file = null;
                const fileInput = document.getElementById('file');
                if (fileInput) fileInput.value = '';
                return;
            }
            if (value && this.newContainer.file) {
                this.loadContainerFile(this.newContainer.file);
            }
        }
    },
    methods: {
        async fetchVcnList() {
            const token = localStorage.getItem('access_token');
            try {
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const response = await axios.get('/active_vcn_list/', config);
                var data = []
                data.push({ "vcnID": 0, "vcnName": "Select VCN", "vesselID": 0, "import_voyage": 0, "export_voyage": 0, "MlocID": 0, "ImpRotNo": "", "ImpRotDate": null, "ExpRotNo": "", "ExpRotDate": null, "BerthDate": null, "EgmDate": null, "SailDate": null, "IsSail": 0, "vesselLocation": 0, "created_by": 0, "CreateDate": null, "last_modified_by": 0, "ModiDate": null, "VesselName": "", "import_voyageName": "", "export_voyageName": "", "area": "", "Vesselarea": "" })
                data.push(...response.data[2]);
                console.log('Fetched VCN list:', data);
                this.vcns = data;
                this.newContainer.vcnID = 0;
            } catch (error) {
                console.error('Error fetching VCN list:', error);
                useToast().error(error.response?.data?.message || 'Error fetching VCN list.');
            }
        },
        FillVCNDetails(value) {
            //const vcnID = this.newContainer.vcnID
            const selvcn = this.vcns.find(vcn => vcn.vcnID === value);
            if (selvcn.vcnID !== 0) {
                if (selvcn) {
                    this.newContainer.vesselID = selvcn.vesselID
                    this.newContainer.VoyId = selvcn.export_voyage
                    this.newContainer.voyage = selvcn.export_voyageName
                    this.newContainer.locID = selvcn.MlocID
                }
            }
        },
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.accountID = AppAcc.accountid
        },
        handleFileUpload(event) {
            const file = event.target.files[0];

            if (file && !this.isAllowedFile(file, this.newContainer.isEmpty)) {
                this.newContainer.file = null;
                event.target.value = '';
                useToast().error(this.newContainer.isEmpty
                    ? 'Select an XLS or XLSX file.'
                    : 'Select an XLS, XLSX, or ZIP file.');
                return;
            }

            this.newContainer.file = file;

            if (this.newContainer.isEmpty && file) {
                this.loadContainerFile(file);
            }
        },
        isAllowedFile(file, isEmpty) {
            const extension = file.name.split('.').pop().toLowerCase();
            const allowedExtensions = isEmpty ? ['xls', 'xlsx'] : ['xls', 'xlsx', 'zip'];
            return allowedExtensions.includes(extension);
        },
        loadContainerFile(file) {
            const extension = file.name.split('.').pop().toLowerCase();
            const reader = new FileReader();

            reader.onload = event => {
                try {
                    if (extension === 'xlsx' || extension === 'xls') {
                        const workbook = XLSX.read(event.target.result, { type: 'array' });
                        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                        this.advanceContainerText = XLSX.utils.sheet_to_csv(firstSheet, {
                            FS: '\t',
                            blankrows: false,
                        });
                    } else {
                        this.advanceContainerText = event.target.result;
                    }

                    this.parseAdvanceContainerRows();
                } catch (error) {
                    console.error('Error reading container file:', error);
                    useToast().error('Unable to read the selected container file.');
                }
            };

            reader.onerror = () => {
                useToast().error('Unable to read the selected container file.');
            };

            if (extension === 'xlsx' || extension === 'xls') {
                reader.readAsArrayBuffer(file);
            } else {
                reader.readAsText(file);
            }
        },
        parseAdvanceContainerRows() {
            const lines = this.advanceContainerText
                .split(/\r?\n/)
                .map(line => line.trim())
                .filter(Boolean);

            this.advanceContainerRows = lines
                .map(line => line.split(/\t|\s{2,}/).map(value => value.trim()))
                .filter(columns => columns.length >= 5)
                .filter(columns => columns[2].toLowerCase() !== 'equipment#')
                .map(columns => ({
                    location: columns[0],
                    depot: columns[1],
                    equipment: columns[2],
                    size: columns[3],
                    type: columns[4],
                }));
        },
        async uploadFiles() {
            if (this.isSubmitting) return;            
            this.uploadlist = [];
            if (this.newContainer.partyName == 0) {
                useToast().error("Select party");
                return;
            }
            this.updateApplicantAccountIds(this.newContainer.partyName)

            const selvcn = this.vcns.find(vcn => vcn.vcnID === this.newContainer.vcnID);
            //console.log(selvcn)
            if (selvcn.vcnID !== 0) {
                if (selvcn) {
                    this.newContainer.vesselID = selvcn.vesselID
                    this.newContainer.VoyId = selvcn.export_voyage
                    this.newContainer.voyage = selvcn.export_voyageName
                    this.newContainer.locID = selvcn.MlocID
                }
            } else {
                useToast().error("Select VCN");
                return;
            }
            const selvessel = this.vessel.find(vessel => vessel.Vesselid === this.newContainer.vesselID);
            if (selvessel.Vesselid !== 0) {
                if (selvessel) {
                    this.newContainer.consign = selvessel.txtColsign
                    this.newContainer.vesselname = selvessel.Name
                }
            } else {
                useToast().error("Select vessel");
                return;
            }
            const selport = this.ports.find(port => port.portid === this.newContainer.pod);
            if (selport.portid !== 0) {
                if (selport) {
                    this.newContainer.podcode = selport.PortCode
                }
            } else {
                useToast().error("Select Transipment Port");
                return;
            }

            if (this.newContainer.locID == 0) {
                useToast().error("Select location");
                return;
            }
            if (!this.newContainer.isEmpty)
            {
                if (this.newContainer.file == null) {
                    useToast().error("Select file");
                    return;
                }
            }
            else if(this.newContainer.isEmpty==true)
            {
                if (this.advanceContainerRows.length === 0 && this.newContainer.file == null) {
                    useToast().error("Paste container list for empty containers or select file");
                    return;
                }
            }
            if (this.newContainer.consign == null) {
                useToast().error("Vessel colsign not entered");
                return;
            }

            this.isSubmitting = true;
            
            try {
                //console.log(this.newContainer);
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                
                const data = new FormData();
        
                if (this.newContainer.file != null) {
                    data.append('file', this.newContainer.file);
                }
                var response=null;
                try {
                    if(this.newContainer.isEmpty==true)
                    {
                        var config = {
                            headers: {
                                'accept': 'application/json',
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'multipart/form-data'
                            },
                        };
                        if (this.newContainer.file == null) {
                            config = {
                                headers: {
                                    'accept': 'application/json',
                                    'Authorization': `Bearer ${token}`
                                },
                            };
                        }
                        const containerData = JSON.stringify(this.advanceContainerRows);
                        data.append('dataset', containerData);
                        response = await axios.post('/convert_mt_cartin?applicant=' + this.newContainer.applicantID + '&accountid=' + this.newContainer.accountID + '&vesselid=' + this.newContainer.vesselID + '&voyageid=' + this.newContainer.VoyId + '&loc=' + this.newContainer.locID + '&consign=' + this.newContainer.consign + '&vesselname=' + this.newContainer.vesselname + '&voyage=' + this.newContainer.voyage + '&transhipment=' + this.newContainer.podcode.trim() + '&pod=' + this.newContainer.pod+'&israil='+this.newContainer.israil+'&is_soc='+this.newContainer.is_soc, data, config);
                    }
                    else
                    {
                        const config = {
                            headers: {
                                'accept': 'application/json',
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'multipart/form-data'
                            },
                        };
                        data.append('dataset', '');
                        response = await axios.post('/convert_cartin?applicant=' + this.newContainer.applicantID + '&accountid=' + this.newContainer.accountID + '&vesselid=' + this.newContainer.vesselID + '&voyageid=' + this.newContainer.VoyId + '&loc=' + this.newContainer.locID + '&consign=' + this.newContainer.consign + '&vesselname=' + this.newContainer.vesselname + '&voyage=' + this.newContainer.voyage + '&transhipment=' + this.newContainer.podcode.trim() + '&pod=' + this.newContainer.pod+'&israil='+this.newContainer.israil+'&is_soc='+this.newContainer.is_soc, data, config);
                    }
                } catch (error) {
                    console.log("STATUS:", error.response?.status);
                    console.log("DETAIL:", error.response?.data);
                }
                //console.log(response)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    this.uploadlist = response.data[2]
                    if (response.data[3] != '') {
                        useToast().success("File Downloaded");
                        this.downloadcoprar(response.data[3])
                    }else{                    
                        useToast().error("File has errors");
                    }
                }
            } catch (error) {
                console.error('Error uploading file:', error);
                useToast().error(error.response?.data?.message || 'Error converting file.');
            } finally {
                this.isSubmitting = false;
            }
        },
        async downloadcoprar(filename) {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    responseType: 'blob'
                };
                const urlpath = `/download_coprar_txt?filenm=${filename}`;
                //console.log(urlpath)
                const response = await axios.post(urlpath, config);
                const blob = new Blob([response.data], { type: 'application/octet-stream' });
                saveAs(blob, filename);
            } catch (error) {
                console.error('Error downloading file:', error);
                useToast().error(error.response?.data?.message || 'Error downloading file.');
            }
        },
        async generatepdf() {
            if (this.isSubmitting) return;
            
            if (!this.oldcoprarno.trim()) {
                useToast().error('Old Coprar No is required.');
                return;
            }
            if (!this.newcoprarno.trim()) {
                useToast().error('New Coprar No is required.');
                return;
            }
            if (this.newContainer.partyName == 0) {
                useToast().error('Please select a party.');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                //console.log(this.oldcoprarno)
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    },
                };
                this.updateApplicantAccountIds(this.newContainer.partyName)
                
                const response = await axios.post('/convert_cartin_pdf?coprarno=' + this.oldcoprarno + '&newcoprarno=' + this.newcoprarno + '&applicant=' + this.newContainer.applicantID + '&accountid=' + this.newContainer.accountID+'&filetype='+this.filetype, config, { responseType: 'blob' });
                //console.log(response)
                
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    if (response.data['type'] == 'application/zip') {
                        useToast().success("File Downloaded");
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        saveAs(blob);
                    } else if (response.data['type'] == 'application/pdf') {
                        useToast().success("File Downloaded");
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        saveAs(blob);
                    }else if (response.data['type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                        useToast().success("File Downloaded");
                        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        saveAs(blob);
                    } else {
                        useToast().error("File has errors");
                    }
                }
            } catch (error) {
                console.error('Error generating PDF:', error);
                useToast().error(error.response?.data?.message || 'Error generating PDF.');
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}

</script>
<style scoped>
.table-container {
    /*max-height: 100%;*/
    overflow: auto;
    border: 1px solid #ddd;
    border-radius: 10px;
}

.transaction-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
}

.transaction-table th,
.transaction-table td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.transaction-table th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.transaction-table th .filter-icon {
    cursor: pointer;
    margin-left: 5px;
}

.transaction-table .status-error td {
    background-color: #f8d7da;
    color: #842029;
    font-weight: bold;
}

/* Form group styling for form elements */
.field-p-100 {
    width: 100%;
}

.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 30%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}


.container-input-table {
    width: 100%;
    margin-top: 12px;
    border-collapse: collapse;
}

.container-input-table th,
.container-input-table td {
    padding: 8px;
    text-align: left;
    border: 1px solid #ddd;
}

.container-input-table th {
    background-color: #f2f2f2;
    font-weight: bold;
}
</style>